// The deal's approval rounds (TX-US-0043, AC13): each submission, decision and withdrawal, who
// made it, when and why, read from the deal's events.

import { roundsOf } from './timeline.js';

export default function DealRounds({ events }) {
  const rounds = roundsOf(events);
  if (rounds.length === 0) return <p className="muted">No rounds yet.</p>;
  return (
    <div className="table-scroll">
      <table className="data-table deal-rounds">
        <thead>
          <tr>
            <th className="plain">Round</th>
            <th className="plain">What</th>
            <th className="plain">Who</th>
            <th className="plain">When</th>
            <th className="plain">Reason</th>
          </tr>
        </thead>
        <tbody>
          {rounds.map((row, index) => (
            <tr key={`${row.at}-${index}`}>
              <td>{row.round}</td>
              <td>{row.what}</td>
              <td>{row.by}</td>
              <td className="when">{new Date(row.at).toLocaleString()}</td>
              <td>{row.reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
